import Checkbox from 'src/components/primitives/Checkbox/Checkbox';
import useCurrentSettings from 'src/hooks/useCurrentSettings';
import { cj } from 'src/utils/classNames';

interface Props {
	showCollateral: boolean;
	setShowCollateral: (showCollateral: boolean) => void;
	triggeredFromPositionClose: boolean | undefined;
	className?: string;
}

export default function PnlModalOptions({
	showCollateral,
	setShowCollateral,
	triggeredFromPositionClose,
	className,
}: Props) {
	const [savedSettings, setSavedSettings] = useCurrentSettings();

	const toggleShowCollateral = () => {
		setShowCollateral(!showCollateral);
	};

	const toggleShowPnlOnClose = () => {
		setSavedSettings({
			...savedSettings,
			showPnlOnClose: !savedSettings.showPnlOnClose,
		});
	};

	return (
		<div className={cj('flex', className)}>
			<Checkbox.Default
				className="w-fit"
				id="pnl-modal-show-collateral"
				label="Show collateral"
				checked={showCollateral}
				onCheckedChange={toggleShowCollateral}
			/>
			{triggeredFromPositionClose && (
				<Checkbox.Default
					className="w-fit"
					id="pnl-modal-dont-show-pnl-on-close"
					label="Don't show again when closing"
					checked={!savedSettings.showPnlOnClose}
					onCheckedChange={toggleShowPnlOnClose}
					tooltip={{ content: 'Show/hide automatically when closing position' }}
				/>
			)}
		</div>
	);
}
